import { Box } from '@hivebrite/design-system/Box';
import { Container } from '@hivebrite/design-system/Container';
import { useTheme } from '@hivebrite/design-system/Theme';

import Grid, { Row, Col } from 'hb-react/shared/components/DesignSystem/Grid';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout = ({ children }: LayoutProps) => {
  const theme = useTheme();

  return (
    <Box bg={theme.themeVariables.appHeaderBackgroundColor}>
      <Container height="auto">
        <Grid width="100%">
          <Row>
            <Col width={1}>{children}</Col>
          </Row>
        </Grid>
      </Container>
    </Box>
  );
};

export default Layout;
